import { motion } from 'framer-motion';
import { useRef } from 'react';
import { memo } from 'react';
import { useScrollProgress } from '~/lib/hooks/useScrollProgress';
import type { AnyPromptCommand } from '~/lib/stores/command/types';
import { useScrollOverflowMask } from '~/utils/scroll-overflow-mask';

const PromptDetails = memo(({ command }: { command: AnyPromptCommand }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScrollProgress(contentRef);
  const maskImage = useScrollOverflowMask(scrollYProgress);

  return (
    <div
      onMouseDown={(event) => event.stopPropagation()}
      className="rounded-lg shadow-lg border hidden lg:grid border-bolt-elements-borderColor bg-bolt-elements-background-depth-3 w-full w-screen shadow-lg max-h-[var(--radix-popper-anchor-height)] overflow-hidden grid-rows-[auto_1fr] relative"
      style={{
        maxWidth: 'min(var(--radix-popper-anchor-width), calc(var(--radix-popper-available-width) - 8px))',
      }}
    >
      <div className="flex items-center gap-6 bg-bolt-elements-background-depth-2 px-6 py-3 rounded-t-lg border-b border-bolt-elements-borderColor">
        <h2 className="text-sm font-medium">{command.name}</h2>
      </div>

      <motion.div
        ref={contentRef}
        style={{ maskImage }}
        className="p-6 border border-transparent whitespace-pre-wrap text-sm leading-normal overflow-auto"
      >
        {command.prompt}
      </motion.div>
    </div>
  );
});

PromptDetails.displayName = 'PromptDetails';

export { PromptDetails };
